import { ActionInterface } from './action.interface';
import { Observable } from 'rxjs/Observable';
import { DossierPrestationsService } from '../../../shared/services/dossierPrestations.service';
import { Injectable } from '@angular/core';
import { Folders } from '../../../shared/models/folder/folder.interface';
import FolderInterface = Folders.FolderInterface;

@Injectable()
export class FolderAction implements ActionInterface {
  public constructor(
    private dossierPrestationsService: DossierPrestationsService
  ) {
  }

  /**
   * @param {FolderInterface} folder
   * @returns {Observable<Array<any>>}
   */
  getAvailablePayment(folder: FolderInterface): Observable<Array<any>> {
    return this.dossierPrestationsService.getAvailablePayments(folder);
  }

  /**
 * @param {FolderInterface} folder
 * @returns {Observable<Array<any>>}
 */
  getAvailableModeleEcheancier(folder: FolderInterface): Observable<Array<any>> {
    console.log('no');
    // Pas d'échéancier dans les dossiers de RSF
    return Observable.empty<Array<any>>();

  }
}



// WEBPACK FOOTER //
// ./src/core/payment/actions/folder.action.ts